"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var _flags = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/flags"));
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "kiwi-container",
    class: {
      /* 'kiwi-container-' + bufferType: true, */
      'kiwi-container--sidebar-drawn': _vm.sidebarState.isDrawn,
      'kiwi-container--sidebar-open': _vm.sidebarState.isOpen,
      'kiwi-container--no-sidebar': _vm.buffer && _vm.buffer.isSpecial
    }
  }, [_vm.buffer ? [_c('div', {
    staticClass: "kiwi-container-toggledraw-statebrowser",
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        return _vm.toggleStateBrowser.apply(null, arguments);
      }
    }
  }, [_c('div', {
    staticClass: "kiwi-container-toggledraw-statebrowser-messagecount",
    class: [_vm.unreadMessages.highlight ? 'kiwi-container-toggledraw-statebrowser-messagecount--highlight' : '']
  }, [_c('span', {
    staticClass: "kiwi-container-statebrowser-messagecount-alert"
  }, [_vm._v(" " + _vm._s(_vm.unreadMessages.count > 999 ? '999+' : _vm.unreadMessages.count) + " ")]), _vm._m(0)])]), _c('container-header', {
    attrs: {
      "buffer": _vm.buffer,
      "sidebar-state": _vm.sidebarState
    }
  }), _vm.showBufferTabs ? _c('div', {
    staticClass: "kiwi-buffer-tabs-wrapper"
  }, [_c('div', {
    staticClass: "kiwi-buffer-tabs-arrow kiwi-buffer-tabs-arrow--left",
    class: {
      'kiwi-buffer-tabs-arrow--disabled': !_vm.canScrollLeft
    },
    on: {
      "click": function click($event) {
        return _vm.scrollTabs('left');
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-left",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _c('div', {
    ref: "bufferTabs",
    staticClass: "kiwi-buffer-tabs"
  }, _vm._l(_vm.tabBuffers, function (tabBuffer) {
    return _c('div', {
      key: tabBuffer.id,
      staticClass: "kiwi-buffer-tab",
      class: {
        'kiwi-buffer-tab--active': tabBuffer === _vm.buffer,
        'kiwi-buffer-tab--highlight': (0, _flags.default)(tabBuffer).highlight,
        'kiwi-buffer-tab--unread': ((0, _flags.default)(tabBuffer).unread || 0) > 0
      },
      on: {
        "click": function click($event) {
          return _vm.setActiveBuffer(tabBuffer);
        }
      }
    }, [_c('span', {
      staticClass: "kiwi-buffer-tab-icon"
    }, [_vm.isQueryBuffer(tabBuffer) ? _c('i', {
      staticClass: "fa fa-user",
      attrs: {
        "aria-hidden": "true"
      }
    }) : _c('i', {
      staticClass: "fa fa-hashtag",
      attrs: {
        "aria-hidden": "true"
      }
    })]), _c('span', {
      staticClass: "kiwi-buffer-tab-name"
    }, [_vm._v(_vm._s(tabBuffer.name))]), (0, _flags.default)(tabBuffer).unread ? _c('span', {
      staticClass: "kiwi-buffer-tab-unread"
    }, [_vm._v(" " + _vm._s((0, _flags.default)(tabBuffer).unread > 99 ? '99+' : (0, _flags.default)(tabBuffer).unread) + " ")]) : _vm._e(), _c('span', {
      staticClass: "kiwi-buffer-tab-close",
      on: {
        "click": function click($event) {
          $event.preventDefault();
          $event.stopPropagation();
          return _vm.onCloseClick(tabBuffer, $event);
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-times",
      attrs: {
        "aria-hidden": "true"
      }
    })])]);
  }), 0), _c('div', {
    staticClass: "kiwi-buffer-tabs-arrow kiwi-buffer-tabs-arrow--right",
    class: {
      'kiwi-buffer-tabs-arrow--disabled': !_vm.canScrollRight
    },
    on: {
      "click": function click($event) {
        return _vm.scrollTabs('right');
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-right",
    attrs: {
      "aria-hidden": "true"
    }
  })])]) : _vm._e(), _vm._t("before"), _vm.buffer.getNetwork().state !== 'connected' && !_vm.buffer.isServer() ? _c('not-connected', {
    attrs: {
      "buffer": _vm.buffer,
      "network": _vm.buffer.getNetwork()
    }
  }) : _vm._e(), _c('div', {
    staticClass: "kiwi-container-content"
  }, [_vm.buffer.isServer() ? [_c('server-view', {
    attrs: {
      "network": _vm.network
    }
  })] : [_c('message-list', {
    attrs: {
      "buffer": _vm.buffer
    }
  }), !_vm.buffer.isSpecial() ? _c('sidebar', {
    attrs: {
      "network": _vm.network,
      "buffer": _vm.buffer,
      "sidebar-state": _vm.sidebarState
    }
  }) : _vm._e()], _vm._t("after")], 2)] : [_c('div', {
    staticClass: "kiwi-container-empty"
  }, [_c('h4', [_vm._v(_vm._s(_vm.$t('container_welcome')))]), _c('a', {
    staticClass: "u-button",
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        return _vm.toggleStateBrowser.apply(null, arguments);
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('container_statebrowser')) + " ")])])], _vm.confirmCloseBufferData && _vm.isChannelBuffer(_vm.confirmCloseBufferData) ? _c('div', {
    staticClass: "kiwi-buffer-close-confirm-overlay",
    on: {
      "click": function click($event) {
        if ($event.target !== $event.currentTarget) return null;
        return _vm.cancelCloseBuffer.apply(null, arguments);
      }
    }
  }, [_c('div', {
    staticClass: "kiwi-buffer-close-confirm"
  }, [_c('h4', {
    staticClass: "kiwi-buffer-close-confirm-title"
  }, [_c('i', {
    staticClass: "fa fa-sign-out",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Leave " + _vm._s(_vm.confirmCloseBufferData.name) + "? ")]), _c('p', {
    staticClass: "kiwi-buffer-close-confirm-message"
  }, [_vm._v(" Are you sure you want to leave this channel? ")]), _c('div', {
    staticClass: "kiwi-buffer-close-confirm-actions"
  }, [_c('button', {
    staticClass: "u-button u-button-secondary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancelCloseBuffer
    }
  }, [_vm._v(" Cancel ")]), _c('button', {
    staticClass: "u-button u-button-warning",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.doCloseBuffer
    }
  }, [_vm._v(" Leave ")])])])]) : _vm._e()], 2);
};
var staticRenderFns = exports.staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('span', {
    staticClass: "kiwi-container-statebrowser-messagecount-close"
  }, [_c('i', {
    staticClass: "fa fa-times",
    attrs: {
      "aria-hidden": "true"
    }
  })]);
}];